import { motion } from 'framer-motion'

const ACCREDITATIONS = [
  {
    src: '/assets/google-partner-badge.png',
    alt: 'Google Partner',
  },
  {
    src: '/assets/google-cloud-generative-ai-leader.png',
    alt: 'Google Cloud Certified — Generative AI Leader',
  },
  {
    src: '/assets/google-ads-search-certified.png',
    alt: 'Google Ads Search Certified',
  },
  {
    src: '/assets/google-cro-certified.png',
    alt: 'Google CRO Certified',
  },
  {
    src: '/assets/nng-ux-certification.png',
    alt: 'Nielsen Norman Group UX Certification',
  },
  {
    src: '/assets/cxl-certified.png',
    alt: 'CXL Certified',
  },
] as const

export default function About() {
  return (
    <section id="about" className="relative py-28 md:py-36 bg-slate-50 border-t border-slate-200/80">
      <div className="container relative z-10">
        <div className="mx-auto max-w-5xl">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            className="text-center"
          >
            <p className="text-sm font-bold text-accent uppercase tracking-[0.2em] mb-5">
              About Us
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-primary uppercase tracking-tight mb-6 md:mb-8">
              End-to-End
              <br />
              <span className="text-accent">Digital Partner.</span>
            </h2>
            <div className="text-base md:text-lg text-slate-600 leading-relaxed max-w-2xl mx-auto space-y-3">
              <p>We&apos;re a Perth-based digital agency built for challenger brands.</p>
              <p>
                Lean, senior, and fast — our strategies and budgets scale with your business,
                whether you&apos;re launching, growing, or leading.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.55, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="mt-16 md:mt-20"
          >
            <div className="flex items-center gap-4 mb-10 md:mb-12">
              <div className="h-px flex-1 bg-slate-200" />
              <p className="text-[11px] md:text-xs font-bold font-heading uppercase tracking-[0.22em] text-slate-400 shrink-0">
                Accreditations
              </p>
              <div className="h-px flex-1 bg-slate-200" />
            </div>

            <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-8 md:gap-x-14 md:gap-y-10 lg:gap-x-16">
              {ACCREDITATIONS.map((item) => (
                <li key={item.src} className="flex items-center justify-center">
                  <img
                    src={item.src}
                    alt={item.alt}
                    className="h-14 md:h-20 lg:h-[5.5rem] w-auto max-w-[9.5rem] md:max-w-[11rem] object-contain opacity-90 transition-opacity duration-300 hover:opacity-100"
                  />
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
